import React from 'react';

interface EclipseMoonProps {
  size?: number;
  style?: React.CSSProperties;
}

export function EclipseMoon({ size = 280, style = {} }: EclipseMoonProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        position: 'relative',
        flex: 'none',
        ...style
      }}
    >
      {/* Corona — soft radial glow */}
      <div
        style={{
          position: 'absolute',
          inset: -size * 0.35,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,244,212,0.38) 0%, rgba(255,225,125,0.22) 28%, rgba(232,168,48,0.08) 52%, transparent 72%)',
          filter: 'blur(6px)',
          animation: 'glow 4s ease-in-out infinite alternate',
        }}
      />
      {/* Bright disc peeking out */}
      <div
        style={{
          position: 'absolute',
          top: '12%',
          left: '10%',
          width: '72%',
          height: '72%',
          borderRadius: '50%',
          background: '#FCCA36',
          boxShadow: '0 0 42px rgba(252,202,54,0.45)',
        }}
      />
      {/* Occluder — the planet / cloak */}
      <div
        style={{
          position: 'absolute',
          top: '6%',
          right: '6%',
          width: '56%',
          height: '56%',
          borderRadius: '50%',
          background: '#1C2230',
          boxShadow: '0 0 0 2px rgba(255,255,255,0.04)',
        }}
      />
      {/* Occluder highlight — white crescent on the occluder */}
      <div
        style={{
          position: 'absolute',
          top: '4%',
          right: '10%',
          width: '48%',
          height: '48%',
          borderRadius: '50%',
          background: '#FFFFFF',
        }}
      />
    </div>
  );
}
